export default __webpack_public_path__ + "static/media/alinma.4c7f8eef.png";